<template>
<div class="chapter">
<div class="inner_page">
<h1>Die polnischen</h1>
<h2 class="sigil_not_in_toc">Bauern I – Herbst</h2>
<h3 class="sigil_not_in_toc">Wladyslaw Stanislaw Reymont</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?03f46ddc